export default function isBookingProductSelected (bookingProduct, otherBookingProduct) {
    return bookingProduct.product.id === otherBookingProduct.product.id
}
